import React from "react";
import Experience from "../Items/Experience";

const experiencesData = [
  {
    id: 1,
    year: "Apr 2022 - present",
    degree: "Frontend Developer @ Varens Softech",
    content:
      "",
  },
  {
    id: 2,
    year: "Jun 2021 - Aug 2022",
    degree: "Frontend Developer @ Foodlocker",
    content:
      "Foodlocker uses data science and demand matching technologies to fulfill the specific demand requirements of large buyers by upscaling the production capabilities of smallholder farmers.",
  },
  {
    id: 3,
    year: "Jan 2020 - Present",
    degree: "Freelance Developer",
    content:
      "Design and Develop website for SME for business purpose and for personal use. Develop modern and highly-demanded tech stacks of the 21st century.",
  },
  {
    id: 4,
    year: "Jun 2019 - Nov 2019",
    degree: "Software Developer Intern @ DeCloud23 Tech",
    content:
      "DeCloud23 Technologies is a company that is focused on developing solutions that is best fit for the business requirements of clients across various industries.",
  },
];

function Experiences() {
  return (
    <div className="timeline">
      {experiencesData.map((experience) => (
        <Experience experience={experience} key={experience.id} />
      ))}
      <span className="timeline-line"></span>
    </div>
  );
}

export default Experiences;
